// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".privacyPolicy_root__2cOfR {\n  padding: 40px;\n  box-sizing: border-box;\n  background: #fff;\n  height: calc(100% - 80px); }\n  .privacyPolicy_root__2cOfR .privacyPolicy_container__2EkAh {\n    max-width: 1000px;\n    margin: 0px auto;\n    overflow: auto;\n    height: 100%;\n    padding-right: 10px;\n    box-sizing: border-box; }\n    .privacyPolicy_root__2cOfR .privacyPolicy_container__2EkAh .privacyPolicy_newText__OWqzh {\n      text-align: justify;\n      line-height: 24px; }\n", ""]);
// Exports
exports.locals = {
	"root": "privacyPolicy_root__2cOfR",
	"container": "privacyPolicy_container__2EkAh",
	"newText": "privacyPolicy_newText__OWqzh"
};
module.exports = exports;
